import { render, staticRenderFns } from "./MallNoData.vue?vue&type=template&id=35e6556b&scoped=true"
import script from "./MallNoData.vue?vue&type=script&lang=js"
export * from "./MallNoData.vue?vue&type=script&lang=js"
import style0 from "./MallNoData.vue?vue&type=style&index=0&id=35e6556b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6556b",
  null
  
)

export default component.exports